import { Injectable } from '@angular/core';

import {
  CallCentreStatus,
  ComplianceStatusHttpModel,
} from '@cp/shared/data-access/http/compliance/compliance-http.models';
import { AvailableComplianceNotifications } from '../+state/notification.models';
import { NotificationStateService } from './notification-state.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private _notificationService: NotificationStateService) {}

  public populateNotificationsForComplianceStatus(
    complianceStatus: ComplianceStatusHttpModel,
  ): void {
    this._notificationService.removeComplianceNotification(
      AvailableComplianceNotifications.dueToExpire,
    );

    if (complianceStatus.updateSoon > 0) {
      this._notificationService.addComplianceNotification(
        AvailableComplianceNotifications.dueToExpire,
      );
    }
  }

  public populateNotificationForCallCentreStatus(
    callCentreStatus: CallCentreStatus,
  ): void {
    this._notificationService.removeComplianceNotification(
      AvailableComplianceNotifications.expired,
    );
    this._notificationService.removeComplianceNotification(
      AvailableComplianceNotifications.lapsed,
    );

    switch (callCentreStatus) {
      case 'NotNow':
        this._notificationService.addComplianceNotification(
          AvailableComplianceNotifications.expired,
        );
        return;
      case 'Lapsed':
        this._notificationService.addComplianceNotification(
          AvailableComplianceNotifications.lapsed,
        );
        return;
      case 'Ok':
      default:
        return;
    }
  }

  public populateNotificationForTraining(): void {
    // todo: banner was removed from TNSDS-6106 and removed from MVP
    // this._notificationService.removeTrainingNotification(
    //   AvailableTrainingNotifications.trainingCancelled
    // );
    //
    // this._notificationService.addTrainingNotification(
    //   AvailableTrainingNotifications.trainingCancelled
    // );
  }
}
